package com.essntl.features.address.ui

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.address.domain.model.AddressModel

data class AddressState(
    val getAddress: State<AddressModel> = State(),
    val address: MutableState<AddressModel> = mutableStateOf(AddressModel.empty),
    val addEditAddress: State<AddressModel> = State(),
)
